import {
  BACKWARDS_BOGO_SUBEXPERIENCE_TAGS,
  DOLLAR_THRESHOLD_BOGO_SUBEXPERIENCE_TAGS,
  EXPERIENCE_TAGS,
  FORWARDS_BOGO_SUBEXPERIENCE_TAGS,
  MSB_SUBEXPERIENCE_TAGS,
  BMSM_SUBEXPERIENCE_TAGS
} from './constants';

const getMinimumPurchaseQuantityBound = (itemGroup, isBXG1Enabled) => {
  if (itemGroup === 'SRC-1') {
    return isBXG1Enabled
      ? 2.0
      : 1.0;
  }
  if (itemGroup === 'TGT-1') {
    return isBXG1Enabled
      ? 2.0
      : 1.0;
  }
  return 1.0;
};

const boundedMinimumPurchaseQuantity = (pr, bound) => {
  if (!(pr && pr.thresholdType && pr.minThresholdVal)) {
    return false;
  }
  return pr.thresholdType === 'QUANTITY'
    && pr.minThresholdVal > 0
    && pr.minThresholdVal <= bound;
};

const isBogoFree = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].rewardType && tiers[0].rewardVal)) {
    return false;
  }
  return tiers[0].rewardType === 'PERCNTOFF'
    && tiers[0].rewardVal === 100.0;
};

const isBogoPercentOff = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].rewardType && tiers[0].rewardVal)) {
    return false;
  }
  return tiers[0].rewardType === 'PERCNTOFF'
    && tiers[0].rewardVal < 100.0
    && tiers[0].rewardVal > 0;
};

const isBogoDollarOff = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].rewardType && tiers[0].rewardVal)) {
    return false;
  }
  return tiers[0].rewardType === 'AMTOFF'
    && tiers[0].rewardVal > 0;
};

const isBackwardsBogo = (skuItemGroup) => {
  return skuItemGroup === 'TGT-1';
};

const isQuantityPercentageOff = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardType)) {
    return false;
  }
  return tiers[0].thresholdType === 'QUANTITY'
    && tiers[0].rewardType === 'PERCNTOFF';
};

const isQuantityAmountPerOrder = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardLevel)) {
    return false;
  }
  return tiers[0].thresholdType === 'QUANTITY'
    && tiers[0].rewardLevel === 'ORDER';
};

const isQuantityAmountPerItem = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardLevel)) {
    return false;
  }
  return tiers[0].thresholdType === 'QUANTITY'
    && tiers[0].rewardLevel === 'ITEM';
};

const isQuantityFixedPrice = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardType)) {
    return false;
  }
  return tiers[0].thresholdType === 'QUANTITY'
    && tiers[0].rewardType === 'FIXEDPRICE';
};

const isAmountPercentageOff = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardType)) {
    return false;
  }
  return tiers[0].thresholdType === 'AMOUNT'
    && tiers[0].rewardType === 'PERCNTOFF';
};

const isAmountAmountPerOrder = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardLevel)) {
    return false;
  }
  return tiers[0].thresholdType === 'AMOUNT'
    && tiers[0].rewardLevel === 'ORDER';
};

const isAmountAmountPerItem = (tiers) => {
  if (tiers?.length > 0 && !(tiers[0].minThresholdVal && tiers[0].rewardVal
    && tiers[0].thresholdType && tiers[0].rewardLevel)) {
    return false;
  }
  return tiers[0].thresholdType === 'AMOUNT'
    && tiers[0].rewardLevel === 'ITEM';
};

const isRegularBogoFree = (qualifying, reward, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoFree(tiers);
};

const isRegularBogoPercent = (qualifying, reward, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoPercentOff(tiers);
};

const isRegularBogoDollar = (qualifying, reward, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoDollarOff(tiers);
};

const isBXG1Free = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoFree(tiers);
};

const isBXG1Percent = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoPercentOff(tiers);
};

const isBXG1Dollar = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(reward, 1.0)
    && isBogoDollarOff(tiers);
};

const isB1GYFree = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoFree(tiers);
};

const isB1GYPercent = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoPercentOff(tiers);
};

const isB1GYDollar = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(qualifying, 1.0)
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoDollarOff(tiers);
};

const isBXGYFree = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoFree(tiers);
};

const isBXGYPercent = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoPercentOff(tiers);
};

const isBXGYDollar = (qualifying, reward, isBXG1Enabled, tiers) => {
  return boundedMinimumPurchaseQuantity(
    qualifying,
    getMinimumPurchaseQuantityBound(qualifying.itemGroup, isBXG1Enabled)
  )
    && boundedMinimumPurchaseQuantity(
      reward,
      getMinimumPurchaseQuantityBound(reward.itemGroup, isBXG1Enabled)
    )
    && isBogoDollarOff(tiers);
};

const getBogoSubExperience = (tiers, qualifying, reward, skuItemGroup, isBXG1Enabled) => {
  switch (true) {
  case isRegularBogoFree(qualifying, reward, tiers): {
    return isBackwardsBogo(skuItemGroup) ? BACKWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetOne
      : FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetOne;
  }
  case isRegularBogoPercent(qualifying, reward, tiers): {
    return isBackwardsBogo(skuItemGroup) ? BACKWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetPercentageOff
      : FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetPercentageOff;
  }
  case isRegularBogoDollar(qualifying, reward, tiers): {
    // for memorial day promo messaging
    if (tiers?.[0]?.rewardVal === 1) {
      return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyThePairAndSave;
    }
    return isBackwardsBogo(skuItemGroup) ? BACKWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetDollarOff
      : FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetDollarOff;
  }
  case isBXG1Free(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetOne;
  }
  case isBXG1Percent(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetOnePercentageOff;
  }
  case isBXG1Dollar(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetOneDollarOff;
  }
  case isB1GYFree(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetY;
  }
  case isB1GYPercent(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetYPercentageOff;
  }
  case isB1GYDollar(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyOneGetYDollarOff;
  }
  case isBXGYFree(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetY;
  }
  case isBXGYPercent(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetYPercentageOff;
  }
  case isBXGYDollar(qualifying, reward, isBXG1Enabled, tiers): {
    return FORWARDS_BOGO_SUBEXPERIENCE_TAGS.buyXGetYDollarOff;
  }
  case isBogoFree(tiers) && tiers?.[0]?.maxAllowedRewardAmount !== null: {
    return DOLLAR_THRESHOLD_BOGO_SUBEXPERIENCE_TAGS.buyMinAmountGetOne;
  }
  case isBogoPercentOff(tiers) && tiers?.[0]?.maxAllowedRewardAmount !== null: {
    return DOLLAR_THRESHOLD_BOGO_SUBEXPERIENCE_TAGS.buyMinAmountGetPercentageOff;
  }
  case isBogoDollarOff(tiers): {
    return DOLLAR_THRESHOLD_BOGO_SUBEXPERIENCE_TAGS.buyMinAmountGetDollarOff;
  }
  default: {
    return null;
  }
  }
};

const getMultiTiersSubExperience = (tiers, isMSB = false) => {
  if (tiers != null) {
    // BuyXorMoreGetYPercent
    if (isQuantityPercentageOff(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB1 : BMSM_SUBEXPERIENCE_TAGS.BMSM1Categorized;
    }
    // BuyXorMoreSaveYDollar
    if (isQuantityAmountPerOrder(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB2 : BMSM_SUBEXPERIENCE_TAGS.BMSM2Categorized;
    }
    // BuyXorMoreSaveYDollarEach
    if (isQuantityAmountPerItem(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB3 : BMSM_SUBEXPERIENCE_TAGS.BMSM3Categorized;
    }
    // BuyXDollarGetYPercent
    if (isAmountPercentageOff(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB4 : BMSM_SUBEXPERIENCE_TAGS.BMSM4Categorized;
    }
    // BuyXDollarGetYDollar
    if (isAmountAmountPerOrder(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB5 : BMSM_SUBEXPERIENCE_TAGS.BMSM5Categorized;
    }
    // BuyXDollarGetYDollarEach
    if (isAmountAmountPerItem(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB6 : BMSM_SUBEXPERIENCE_TAGS.BMSM6Categorized;
    }
    // BuyXPayYDollars
    if (isQuantityFixedPrice(tiers)) {
      return isMSB ? MSB_SUBEXPERIENCE_TAGS.MSB7 : BMSM_SUBEXPERIENCE_TAGS.BMSM7Categorized;
    }
  }
  return null;
};

export const getSubExperienceTag = (
  promotionTags, tiers, qualifying, reward, skuItemGroup, isBXG1Enabled
) => {
  try {
    if (promotionTags?.length) {
      // for BOGO
      if (promotionTags.includes(EXPERIENCE_TAGS.BOGO)) {
        return getBogoSubExperience(tiers, qualifying, reward, skuItemGroup, isBXG1Enabled);
      }
      // for MSB
      if (promotionTags.includes(EXPERIENCE_TAGS.MSB)) {
        return getMultiTiersSubExperience(tiers, true);
      }
      // for BMSM
      if (promotionTags.includes(EXPERIENCE_TAGS.BMSM)) {
        return getMultiTiersSubExperience(tiers);
      }
      // for Bundle
      if (promotionTags.includes(EXPERIENCE_TAGS.BUNDLE)) {
        return EXPERIENCE_TAGS.BUNDLE;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Error in getSubExperienceTag', err);
  }
  return null;
};

export const getSanitizedRewardTiers = (promotion) => {
  return (promotion?.reward?.tiers || []).slice()
    // Sorts promotion tiers from smallest to largest quantity or amount needed to qualify
    .sort((
      { minThresholdVal: aVal },
      { minThresholdVal: bVal }) => {
      return (aVal < bVal) ? -1 : 1;
    })
    // Guarantees each tier has default value for each key and sets the tier index
    // this changes backend "nulls" to 0. but would we actually prefer the nulls?
    .map((tier, i) => {
      return {
        tier: i,
        minThresholdVal: tier?.minThresholdVal
          || tier?.minPurchaseQuantity
          || tier?.minPurchaseAmount
          || 0,
        thresholdType: tier.thresholdType || '',
        maxAllowedRewardAmount: tier.maxAllowedRewardAmount || 0,
        rewardVal: tier?.rewardVal
          || tier?.rewardPercent
          || tier?.rewardAmountPerOrder
          || tier?.rewardAmountPerItem
          || 0,
        rewardType: tier.rewardType || '',
        rewardLevel: tier.rewardLevel || ''
      };
    });
};